<div class="flex-col gap-4">
  @if (label()) {
    <mat-label class="label">{{ label() }}</mat-label>
  }
  <div class="flex-row gap-4 wrap">
    <div class="trigger-group">
      @if (disabled()) {
        @if (valueElements() && !valueElements().length) {
          <vl-chips class="ml-15" state="disabled" cursor="default">{{ 'multi_checkbox.all' | trans }}</vl-chips>
        }
      } @else {
        <vl-chips
          [matMenuTriggerFor]="familleMenu"
          [iconRight]="icon()"
          [roundedValue]="showNumber() && value()?.length"
          [state]="buttonState()"
          (action)="menuTrigger.openMenu()"
          (menuOpened)="onMenuOpened()"
          #menuTrigger="matMenuTrigger">
          <span class="body-1">
          {{ text() }}
          </span>
        </vl-chips>
      }
      @if (showChips() && valueElements()?.length > 1 && !disabled()) {
        <vl-chips iconRight="clear" [state]="'accent'" (action)="removeAll()"/>
      }
    </div>
  </div>
  <mat-menu #familleMenu="matMenu" class="multi-checkbox-menu">
    @if (selectAll()) {
      <div class="select-all-bar" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <button class="link-btn" (click)="selectAllElements(); $event.stopPropagation()">
          {{ 'multi_checkbox.select_all' | trans }}
        </button>
        <button class="link-btn" (click)="removeAll(); $event.stopPropagation()">
          {{ 'multi_checkbox.deselect_all' | trans }}
        </button>
      </div>
    }
    @if (showTextFilter()) {
      <div class="px-12 py-8" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <vl-input-search class="w100" [(value)]="filterText"/>
      </div>
      @if (selectedElements().length) {
        <div class="selected-section">
          @for (element of selectedElements(); track element.value) {
            <div class="option-item" mat-menu-item (click)="selectElement($event, element)">
              <mat-checkbox [checked]="true"
                            (click)="selectElement($event, element)">{{ element.name }}
              </mat-checkbox>
            </div>
          }
        </div>
        @if (filteredElements()?.length) {
          <div class="separator"></div>
        }
      }
      <div class="options-list">
        @for (element of filteredElements(); track element.value) {
          <div class="option-item" mat-menu-item (click)="selectElement($event, element)">
            <mat-checkbox [checked]="false"
                          (click)="selectElement($event, element)">{{ element.name }}
            </mat-checkbox>
          </div>
        }
      </div>
    } @else {
      @for (element of filteredElements(); track element.value) {
        <div mat-menu-item (click)="selectElement($event, element)">
          <mat-checkbox [checked]="isChecked(element)"
                        (click)="selectElement($event, element)">{{ element.name }}
          </mat-checkbox>
        </div>
      }
    }
    <ng-content></ng-content>
  </mat-menu>
  @if (showChips()) {
    <ng-container *ngTemplateOutlet="chipsTemplate"></ng-container>
  }
</div>

<ng-template #chipsTemplate>
  <div class="flex-row gap-4 wrap align-center" [ngClass]="{'ml-15': disabled()}">
    @for (elem of valueElements(); track $index) {
      @if ($index < maxChips()) {
        @if ($index > 0 && chipsSeparator()) {
          <ng-container *ngTemplateOutlet="chipsSeparator()"></ng-container>
        }
        @if (disabled()) {
          <vl-chips cursor="default" state="enabled">
            {{ elem.name }}
          </vl-chips>
        } @else {
          <vl-chips iconRight="clear" state="enabled" (action)="removeElement(elem)">
            {{ elem.name }}
          </vl-chips>
        }
      }
    }
    @if (valueElements()?.length > maxChips()) {
      @if (chipsSeparator()) {
        <ng-container *ngTemplateOutlet="chipsSeparator()"></ng-container>
      }
      <vl-chips state="enabled">
        <span class="chips-span">
        +{{ valueElements()?.length - maxChips() }}
        </span>
      </vl-chips>
    }
  </div>
</ng-template>
